import { render, staticRenderFns } from "./localchanger.component.html?vue&type=template&id=c8df3274&scoped=true&"
import script from "./localchanger.component.ts?vue&type=script&lang=ts&"
export * from "./localchanger.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8df3274",
  null
  
)

export default component.exports